<template>
  <div class="log-in float-right" style="margin-top: 0px;">
    <div class="nav-menu ul-li">
      <ul style="display: flex;">
        <!-- <li v-show="moduleName==null && displayName==null"><a href="#" @click="register">企业注册</a></li> -->
        <!-- <li v-show="moduleName==null && displayName==null"><a data-toggle="modal" data-target="#loginModal" href="#">登录</a></li> -->
        <li class="menu-item-has-children ul-li-block" v-show="moduleName!=null">
          <router-link :to="{ name: moduleHref}">{{moduleName}}</router-link>
        </li>
        <li class="menu-item-has-children ul-li-block" v-show="displayName!=null">
          <a style="color: #FFF; max-width: 250px; white-space: nowrap; text-overflow: ellipsis; display: block; margin-top: -8px;" href="#" z-index="1000">{{displayName}}</a>
          <div style="width: 100%;display: flex; justify-content: center; align-items: center;">
            <ul class="sub-menu">
              <li><a data-toggle="modal" data-target="#changeModal">修改密码</a></li>
              <li><a @click="exit">退出</a></li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <!-- The Modal -->
    <div class="modal fade" id="loginModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header backgroud-style">
            <div class="gradient-bg"></div>
            <div class="popup-logo">
              <!-- <img src="assets/img/logo/p-logo.jpg" alt=""> -->
            </div>
            <div class="popup-text text-center">
              <h2> <span>登录</span> 您的账号</h2>
            </div>
          </div>

          <!-- Modal body -->
          <div class="modal-body" v-loading="loginFormloading">
            <el-form :model="model" :rules="rules" :validate-on-rule-change="true" ref="loginForm" class="contact_form">

              <el-form-item class="contact-info" prop="UserName">
                <el-input class="k-input-2" v-model.trim="model.UserName" placeholder="身份证号 / 企业名称" @keyup.enter.native="login"></el-input>
              </el-form-item>

              <el-form-item class="contact-info" prop="Password">
                <el-input v-model.trim="model.Password" class="pass" name="password" type="password" placeholder="密码" @keyup.enter.native="login">
                </el-input>
              </el-form-item>
            </el-form>
            <div class="nws-button text-center white text-capitalize">
              <button @click="login">立即登录</button>
            </div>
            <div class="nws-button text-center white " style="display:flex; justify-content: space-between;line-height: 32px;">
              <!-- <span style="color: #ff6715;">{{rules.ErrorMessages}}</span>  -->
              <span style="color:#16cfd0;cursor: pointer;" @click="register">企业注册</span>
              <span style="color:#16cfd0;cursor: pointer;" @click="showForgetPassword">忘记密码</span>
            </div>

            <div class="log-in-footer text-center" style="margin-top:20px;">
              <p>* 企业用户请使用企业名称登录</p>
              <p>* 个人用户请使用身份证号登录</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!-- 忘记密码 -->
    <div class="modal fade" id="forgetPassword" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin: 5.75rem auto;">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header backgroud-style">
            <div class="gradient-bg"></div>
            <div class="popup-logo">
              <!-- <img src="assets/img/logo/p-logo.jpg" alt=""> -->
            </div>
            <div class="popup-text text-center">
              <h2> <span>忘记</span> 密码</h2>
            </div>
          </div>

          <div class="modal-body">
            <el-form :model="forgetModel" :rules="forgetRules" ref="forgetForm" :validate-on-rule-change="true" label-width="0px" class="contact_form">
              <el-form-item class="contact-info" prop="Username">
                <el-input class="name" v-model.trim="forgetModel.Username" placeholder="账号(身份证号/企业名称)"></el-input>
              </el-form-item>

              <el-form-item prop="VerifyCode" class="contact-info" style="width:270px;">
                <div style="display:flex;">
                  <el-input style="width: 270px;" class="name" v-model.trim="forgetModel.VerifyCode" placeholder="验证码"></el-input>
                  <div class="yanzhenma" id="TencentCaptchaWJMM" @click="postSendChangePwdVerifycode(forgetModel)">
                    <a :class="timerNub==0?'link' : 'disabled' ">
                      <span v-if="timerNub!=0">( {{timerNub}} )</span>
                      <span v-else-if="timerNub==0">获取验证码</span>
                    </a>
                  </div>
                </div>
              </el-form-item>

              <el-form-item class="contact-info" prop="Password">
                <el-input v-model.trim="forgetModel.Password" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" placeholder="新的密码"></el-input>
              </el-form-item>

              <el-form-item class="contact-info" prop="NewPassword">
                <el-input v-model.trim="forgetModel.NewPassword" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" placeholder="确认密码"></el-input>
              </el-form-item>

              <div class="nws-button text-center white " style="display:flex; justify-content: space-between;line-height: 32px;">
                <!-- <span style="color:ff6715;">{{rules.ErrorMessages}}</span> -->
              </div>
            </el-form>
            <div class="nws-button text-center white text-capitalize" style="    margin-top: 4px;">
              <button type="submit" @click="changePassword('forgetForm',forgetModel)">修改密码</button>
            </div>

            <div class="log-in-footer text-center" style="margin-top:20px;">
              <p>* 企业用户请使用企业名称登录</p>
              <p>* 个人用户请使用身份证号登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 修改密码 -->
    <div class="modal fade" id="changeModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin: 5.75rem auto;">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header backgroud-style">
            <div class="gradient-bg"></div>
            <div class="popup-logo">
              <!-- <img src="assets/img/logo/p-logo.jpg" alt=""> -->
            </div>
            <div class="popup-text text-center">
              <h2> <span>修改</span> 密码</h2>
            </div>
          </div>

          <div class="modal-body">
            <el-form :model="changeModel" :rules="changeRules" ref="changeForm" :validate-on-rule-change="true" label-width="0px" class="contact_form">
              <el-form-item class="contact-info" prop="Username">
                <el-input class="k-input-zh" v-model.trim="changeModel.Username" placeholder="账号(身份证号/企业名称)" :disabled="true"></el-input>

              </el-form-item>

              <el-form-item prop="VerifyCode" class="contact-info" style="width:270px;">
                <div style="display:flex;">
                  <el-input style="width: 270px;" class="name" v-model.trim="changeModel.VerifyCode" placeholder="验证码"></el-input>

                  <div class="yanzhenma" id="TencentCaptchaSXMM" @click='postSendChangePwdVerifycode(changeModel)'>
                    <a :class="timerNub==0?'link' : 'disabled' ">
                      <span v-if="timerNub!=0">( {{timerNub}} )</span>
                      <span v-else-if="timerNub==0">获取验证码</span>
                    </a>
                  </div>
                </div>
              </el-form-item>

              <el-form-item class="contact-info" prop="Password">
                <el-input v-model.trim="changeModel.Password" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" maxlength="20" placeholder="新的密码"></el-input>
              </el-form-item>

              <el-form-item class="contact-info" prop="NewPassword">
                <el-input v-model.trim="changeModel.NewPassword" class="name" :type="inputType" autocomplete="new-password" @focus="changePasswordinput" maxlength="20" placeholder="确认密码"></el-input>
              </el-form-item>

              <div class="nws-button text-center white " style="display:flex; justify-content: space-between;line-height: 32px;">
                <!-- <span style="color:ff6715;">{{rules.ErrorMessages}}</span> -->
              </div>
            </el-form>
            <div class="nws-button text-center white text-capitalize" style="    margin-top: 4px;">
              <button type="submit" @click="changePassword('changeForm',changeModel)">修改密码</button>
            </div>

            <div class="log-in-footer text-center" style="margin-top:20px;">
              <p>* 企业用户请使用企业名称登录</p>
              <p>* 个人用户请使用身份证号登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录公告 -->
    <div class="modal fade" id="gonggaoModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin: 5.75rem auto;">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header backgroud-style">
            <div class="gradient-bg"></div>
            <div class="popup-logo">
              <!-- <img src="assets/img/logo/p-logo.jpg" alt=""> -->
            </div>
            <div class="popup-text text-center">
              <h2> <span>友情</span>提醒</h2>
            </div>
          </div>

          <div class="modal-body" style="padding: 40px 65px 50px 65px;">

            <div class="nws-button text-center white text-capitalize" style="margin-top: 4px;">
              <img style="max-width:220px;max-height:220px;" :src="qrCodeURL" />
            </div>

            <div v-if="!isMiniQrCode" class="log-in-footer text-center" style="margin-top:20px;">
              <p>尊敬的企业，学员为了让您顺利的通过考试，</p>
              <p>我中心为您提供一项模拟考试增值服务，</p>
              <p>请扫码登录{{isMiniQrCode ? '小程序' : '公众号'}}使用，祝考试成功。</p>
            </div>

            <div v-if="isMiniQrCode" class="log-in-footer text-left" style="margin-top:20px;">
              <p style="text-indent: -12px;">* 扫描二维码使用小程序课程学习、模拟练习</p>
              <p style="text-indent: -12px;">* 选择“{{openWeixinName}}”使用本平台账号密码登录</p>
            </div>

            <div class="nws-button text-center white text-capitalize" style="margin-top: 10px;">
              <button @click="onGGClose">确定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'

import { ProjectSettings } from '../../base/base.js';
export default {
  name: 'jxsz-login',
  data: function () {
    let that = this;
    let validatePass = (rule, value, callback) => {
      if (that.rules.ErrorMessages !== '') {
        callback(new Error(that.rules.ErrorMessages));
      } else {
        callback();
      }
    };
    let validatePass1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码必须为 6 位以上字母或数字'));
      } else {
        if (this.forgetModel.NewPassword !== '') {
          this.$refs.forgetForm.validateField('NewPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.forgetModel.Password) {
        callback(new Error('密码不一致!'));
      } else {
        callback();
      }
    };
    let changeValidatePass1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码必须为 6 位以上字母或数字'));
      } else {
        if (this.changeModel.NewPassword !== '') {
          this.$refs.forgetForm.validateField('NewPassword');
        }
        callback();
      }
    };
    let changeValidatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changeModel.Password) {
        callback(new Error('密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      model: {
        Username: null,
        Password: null
      },
      forgetModel: {
        Username: null,
        Password: null,
        VerifyCode: null,
        NewPassword: null
      },
      changeModel: {
        Username: null,
        Password: null,
        VerifyCode: null,
        NewPassword: null
      },
      moduleName: null,
      moduleHref: null,
      displayName: null,
      rules: {
        UserName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        ErrorMessages: ''
      },
      forgetRules: {
        Username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        VerifyCode: [
          { required: true, message: '请填写验证码', trigger: ['blur', 'change'] }
        ],
        Password: [
          { required: true, validator: validatePass1, trigger: ['blur', 'change'] }
        ],
        NewPassword: [
          { required: true, validator: validatePass2, trigger: ['blur', 'change'] }
        ],
        ErrorMessages: ''
      },
      changeRules: {
        VerifyCode: [
          { required: true, message: '请填写验证码', trigger: ['blur', 'change'] }
        ],
        Password: [
          { required: true, validator: changeValidatePass1, trigger: ['blur', 'change'] }
        ],
        NewPassword: [
          { required: true, validator: changeValidatePass2, trigger: ['blur', 'change'] }
        ]
      },
      timerNub: 0,
      captcha: null,
      qrCodeURL: ProjectSettings.WeiXinURL,
      isMiniQrCode: ProjectSettings.IsMiniQrCode,
      openWeixinName: ProjectSettings.OpenWeixinName,
      projectName: ProjectSettings.Name,
      loginFormloading: false,
      inputType: 'text'
    }
  },
  created: function () {
  },

  mounted: function () {
    let that = this;
    this.moduleName = Cookies.get('moduleName');
    this.moduleHref = Cookies.get('moduleHref');
    this.displayName = Cookies.get('DisplayName');
    this.changeModel.Username = Cookies.get('UserName');
    $('#loginModal').on('hidden.bs.modal', function (e) {
      that.model = {
        Username: null,
        Password: null
      };
      that.$refs.loginForm.resetFields();
    });

    $('#forgetPassword').on('hidden.bs.modal', function (e) {
      that.model = {
        Username: null,
        Password: null
      };
      that.forgetModel = {
        Username: null,
        Password: null,
        VerifyCode: null,
        NewPassword: null
      };
      that.$refs.forgetForm.resetFields();
    });
    $('#changeModal').on('hidden.bs.modal', function (e) {
      that.changeModel = {
        Username: Cookies.get('UserName'),
        Password: null,
        VerifyCode: null,
        NewPassword: null
      };
      that.$refs.changeForm.resetFields();
    });

    window.callbackXGMMYZ = function (res) {

    }
  },

  methods: {
    login() {
      let that = this;
      this.rules.ErrorMessages = '';

      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          let captcha = new TencentCaptcha('2049138413',
            function (res) {
              if (res.ret === 0) {
                that.loginFormloading = true;
                let obj = {
                  Ticket: res.ticket,
                  Randstr: res.randstr
                }
                obj = _.assign(obj, that.model);

                that.$store.dispatch('login', obj).then(response => {
                  that.loginFormloading = false;
                  if (response.MsgCode === 0) {
                    let data = response.Data;
                    Cookies.set('Token', data.Token);
                    Cookies.set('UserName', data.UserName);
                    Cookies.set('DisplayName', data.DisplayName);
                    Cookies.set('UserTypeId', data.UserTypeId);
                    Cookies.set('YYMenus', data.YYMenus);

                    if (data.UserTypeId === 1) {
                      $('#loginModal').modal('hide');
                      Cookies.set('moduleName', '运营管理系统');
                      Cookies.set('moduleHref', data.YYMenus[0]);
                      // that.$router.push({ name: data.YYMenus[0] });
                      let routeUrl = this.$router.resolve({ name: data.YYMenus[0] });
                      console.log('routeUrl', routeUrl)
                      window.location.href = routeUrl;
                    } else if (data.UserTypeId === 2) {
                      Cookies.set('moduleName', '企业管理系统');
                      Cookies.set('moduleHref', 'qyglwdbm');

                      if (that.$route.name === 'courseDetails') {
                        $('#loginModal').modal('hide');
                        window.location.href = 'courseDetails?Id=' + that.$route.query.Id;
                      } else {
                        window.location.href = '/qygl/wdbm';
                        Cookies.set('isGongGao', 'true');
                      }
                    } else if (data.UserTypeId === 3) {
                      Cookies.set('moduleName', '在线学习系统');
                      Cookies.set('moduleHref', 'wdxx');
                      window.location.href = '/zxxxgl/wdxx';
                      Cookies.set('isGongGao', 'true');
                    } else {
                      window.location.href = 'index';
                    }

                    that.moduleName = Cookies.get('moduleName');
                    that.moduleHref = Cookies.get('moduleHref');
                    that.displayName = data.DisplayName;
                  } else if (response.MsgCode === 1) {
                    that.rules.ErrorMessages = response.Message;
                    that.$refs.loginForm.validateField('Password');
                  } else {
                    that.$alert(response.Message, '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                      }
                    });
                  }
                }).catch(err => {
                  that.loginFormloading = false;
                  console.log(err);
                });
              }
            }
          );
          captcha.show();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    exit() {
      Cookies.remove('moduleName');
      Cookies.remove('moduleHref');
      Cookies.remove('Token');
      Cookies.remove('UserTypeId');
      Cookies.remove('UserName');
      Cookies.remove('DisplayName');
      Cookies.remove('YYMenus');
      this.model = {
        UserName: null,
        Password: null
      }
      this.moduleName = null;
      this.moduleHref = null;
      this.displayName = null;
      this.$router.push({ name: 'index' });
    },
    register() {
      $('#loginModal').modal('hide');
      // Cookies.set('moduleName', '企业管理');
      // Cookies.set('moduleHref', '../qygl');
      this.$router.push({ name: 'register' });
    },
    showForgetPassword() {
      $('#loginModal').modal('hide');
      $('#forgetPassword').modal('show');
    },
    postSendChangePwdVerifycode(model) {
      if (!model.Username) {
        this.$alert('请输入正确的账号！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        return;
      }
      if (this.timerNub !== 0) {
        return;
      }
      let that = this;
      let maxtime = 60;

      let captcha = new TencentCaptcha('2049138413',
        function (res) {
          if (res.ret === 0) {
            let obj = {
              Ticket: res.ticket,
              Randstr: res.randstr
            }
            obj = _.assign(obj, model);

            that.$store.dispatch('postSendChangePwdVerifycode', obj).then((response) => {
              if (response.MsgCode === 1) {
                window.clearInterval(window.Interval.timer);
                that.timerNub = 0;
              }
              that.$alert(response.Message, '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  // this.$message({
                  //   type: 'info',
                  //   message: `action: ${ action }`
                  // });
                }
              });
            });
          }
        }
      );
      captcha.show();

      window.Interval.timer = window.setInterval(() => {
        maxtime--;
        that.timerNub = maxtime;
        if (maxtime <= 0) {
          that.timerNub = 0;
          window.clearInterval(window.Interval.timer);
        }
      }, 1000);
    },
    changePassword(refName, model) {
      let that = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          that.$store.dispatch('putChangePassword', model).then(response => {
            if (response.MsgCode === 0) {
              $('#changeModal').modal('hide');
              $('#forgetPassword').modal('hide');
            }
            that.$alert(response.Message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                // let routeUrl = that.$router.resolve({
                //   path: 'index'
                // });
                // window.open(routeUrl.href, '_blank');

                // window.location.href = 'index';
              }
            });
          }).catch(err => {
            console.log(err);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onGGClose() {
      $('#gonggaoModal').modal('hide');
    },
    changePasswordinput() {
      this.inputType = 'password';
    }
  }
};
</script>
<style lang="scss" scoped>
.sub-menu {
  width: 102px;
  left: inherit;
  top: 35px;
  a {
    cursor: pointer;
  }
  &::before {
    left: 41px;
    right: inherit;
  }
  li:hover {
    margin-left: 0px !important;
  }
}
.yanzhenma {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  position: absolute;
  right: -100px;
  top: 5px;
  a {
    color: #16cfd0;
    padding: 0px;
    padding-bottom: 8px;
    cursor: pointer;
    font-size: 14px;
    &.disabled {
      color: #9fabab !important;
      cursor: not-allowed;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    span {
      width: 64px;
    }
  }
}
</style>

<style scoped>
.k-input-zh >>> .el-input__inner {
  background-color: rgb(238, 238, 238) !important;
}
</style>

<style>
.modal-body .contact_form {
  margin-bottom: 0px !important;
}
.modal-dialog .el-form-item {
  margin-bottom: 6px !important;
}
.modal-dialog .el-form-item__error {
  color: #f56c6c;
  font-size: 14px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 15px;
  right: 10px;
  left: initial;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ncrq/login.vue